var map = {
	"./ad/desktop/index.vue": 4781,
	"./ad/mobile/index.vue": 4779,
	"./promo/index.vue": 4782,
	"./recommend-activity-section/card/desktop/index.vue": 4783,
	"./recommend-activity-section/card/index.vue": 4304,
	"./recommend-activity-section/card/mobile/index.vue": 4784,
	"./recommend-activity-section/index.vue": 4780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4258;